<template>
    <div v-if="!componentInApp">
        <component :is="'style'"></component>
        <div class="splide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li v-for="(image, i) in images" :key="image.id" class="splide__slide">
                        <img :src="image.image_url + '&w=480&fit=max'"
                             alt="foto"
                             data-popup="gallery"
                             class="block cursor-pointer mr-16 site__rounded--medium h-320"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <main v-else ref="marquee" class="marquee-slider">

        <component :is="'style'"></component>

        <div class="overflow-hidden">
            <div :id="'marquee-' + _uid" class="marquee-container flex flex-none">
                <div v-for="item in [1,2]" :key="item" ref="slides" class="marquee-slides flex flex-none h-320">
                    <img
                        v-for="image in images"
                        :key="image.id"
                        :src="image.image_url + '&w=480&fit=max'"
                        alt="foto"
                        class="block mr-16 site__rounded--medium h-full"
                    >
                </div>
            </div>
        </div>

    </main>
</template>

<script>
import {runningInBrowser, marquee} from '../../helpers';

export default {
    props: {
        images: {
            required: true,
        },
    },
    data() {
        return {
            componentInApp: runningInBrowser(),
        };
    },
    mounted() {
        if (runningInBrowser()) {
            //marquee(this.$refs.marquee);
        }
    },
};
</script>

<style scoped>
.s-carousel-section {
    animation: slide 70s infinite linear;
}

.s-carousel-section:hover {
    animation-play-state: paused;
}
</style>
